interface SortableUser {
  position?: Array<{ isSigned: boolean }>;
  totalFee: number;
  [key: string]: any;
}

const REALTIME_COLUMNS = [
  "liveProfitNLoss",
  "totValuationGNL",
  "liveUserBalance",
  "totalFee",
  "pureProfitNLoss",
];

export const isActiveUser = (user: SortableUser): boolean => {
  const hasSignedPosition = user.position?.some((p) => p.isSigned) ?? false;
  const hasTodayTrade = user.totalFee !== 0;
  return hasSignedPosition || hasTodayTrade;
};

export const isRealtimeColumn = (columnId: string): boolean => {
  return REALTIME_COLUMNS.includes(columnId);
};

export const sortWithActivePriority = (
  data: SortableUser[],
  sortColumn?: string,
  sortDesc?: boolean,
): SortableUser[] => {
  return [...data].sort((a, b) => {
    const aActive = isActiveUser(a);
    const bActive = isActiveUser(b);

    // 활성 사용자 우선
    if (aActive !== bActive) return aActive ? -1 : 1;

    // 같은 그룹 내 정렬
    if (sortColumn) {
      if (isRealtimeColumn(sortColumn)) {
        // 실시간 컬럼: 숫자 비교
        const aVal = (a[sortColumn] as number) || 0;
        const bVal = (b[sortColumn] as number) || 0;
        return sortDesc ? bVal - aVal : aVal - bVal;
      } else {
        // 정적 컬럼 (id, userName 등): 문자열 비교
        const aVal = String(a[sortColumn] ?? "");
        const bVal = String(b[sortColumn] ?? "");
        const cmp = aVal.localeCompare(bVal);
        return sortDesc ? -cmp : cmp;
      }
    }

    return 0;
  });
};
